var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHumidity01 = function SvgHumidity01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 69.86,
    y1: 459.9,
    x2: 439.86,
    y2: 87.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -111.87,
    y1: 279.14,
    x2: 258.13,
    y2: -92.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 81.64,
    y1: 471.62,
    x2: 451.64,
    y2: 99.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 30.06,
    y1: 420.31,
    x2: 400.06,
    y2: 48.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 134.77,
    y1: 524.45,
    x2: 504.77,
    y2: 152.45,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M506.58,225.09c0-18.91-5.45-37.22-15.77-52.96l-20.39-35c-2.08-3.58-6.68-4.79-10.26-2.71-3.58,2.09-4.79,6.68-2.71,10.26l20.49,35.18c.07.12.14.23.21.35,8.77,13.33,13.41,28.86,13.41,44.89,0,21.85-8.51,42.4-23.97,57.85-15.45,15.43-35.97,23.93-57.8,23.93-.02,0-.05,0-.07,0-45.05-.04-81.71-36.72-81.71-81.78,0-16.04,4.64-31.56,13.41-44.89.08-.11.15-.23.21-.35l68.15-116.98,29.97,51.44c2.08,3.58,6.68,4.79,10.26,2.71,3.58-2.09,4.79-6.68,2.71-10.26l-31.44-53.96c-2.41-4.14-6.71-6.61-11.49-6.6s-9.08,2.47-11.49,6.61l-58.65,100.67L255.62,9.22C252.26,3.45,246.26,0,239.58,0c-6.68,0-12.67,3.45-16.04,9.22L90.91,236.88c-19,28.95-29.05,62.62-29.05,97.4,0,41.15,14.4,81.28,40.55,112.99,1.48,1.8,3.63,2.73,5.79,2.73,1.68,0,3.37-.56,4.77-1.71,3.2-2.64,3.65-7.36,1.01-10.56-23.94-29.03-37.13-65.76-37.13-103.44,0-31.91,9.23-62.8,26.69-89.33.08-.11.15-.23.22-.35L236.51,16.77c.9-1.54,2.31-1.77,3.08-1.77s2.18.23,3.08,1.77l88.32,151.6-2.19,3.76c-10.32,15.75-15.77,34.06-15.77,52.96,0,50.65,39.14,92.36,88.77,96.45.33,4.24.51,8.5.51,12.75,0,43.49-16.94,84.37-47.7,115.1-30.73,30.71-71.57,47.61-115.01,47.61h-.14c-37.12-.03-73.43-12.9-102.23-36.24-3.22-2.61-7.94-2.11-10.55,1.1-2.61,3.22-2.11,7.94,1.1,10.55,31.46,25.5,71.11,39.56,111.66,39.59h.15c47.44,0,92.05-18.47,125.61-52,33.6-33.57,52.1-78.22,52.1-125.71,0-4.22-.17-8.45-.46-12.67,23.19-1.66,44.76-11.47,61.37-28.07,18.3-18.28,28.37-42.59,28.37-68.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.99,117.89c0-10.87-3.13-21.39-9.04-30.45L70.4,22.97c-1.9-3.26-5.42-5.28-9.19-5.28h0c-3.77,0-7.29,2.02-9.19,5.28L14.46,87.43c-5.92,9.06-9.04,19.59-9.04,30.45,0,30.74,25,55.76,55.74,55.79h.05c14.89,0,28.9-5.8,39.43-16.32,10.55-10.54,16.35-24.55,16.35-39.46ZM61.21,158.67h-.03c-22.47-.02-40.75-18.31-40.75-40.78,0-8,2.31-15.74,6.69-22.39.08-.11.15-.23.22-.35l33.88-58.16,33.88,58.16c.07.12.14.23.22.35,4.37,6.65,6.69,14.39,6.69,22.39,0,10.9-4.25,21.15-11.96,28.85-7.7,7.7-17.94,11.93-28.83,11.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277.92,221.83c-3.82-1.6-8.22.19-9.82,4.01l-70.36,167.64c-1.6,3.82.19,8.22,4.01,9.82.95.4,1.93.59,2.9.59,2.93,0,5.71-1.73,6.92-4.6l70.36-167.64c1.6-3.82-.19-8.22-4.01-9.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.44,213.43c-21.28,0-38.59,19.57-38.59,43.62s17.31,43.63,38.59,43.63,38.59-19.57,38.59-43.63-17.31-43.62-38.59-43.62ZM192.44,285.68c-13.01,0-23.59-12.84-23.59-28.62s10.58-28.62,23.59-28.62,23.59,12.84,23.59,28.62-10.58,28.62-23.59,28.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.14,371.68c0,24.05,17.31,43.62,38.59,43.62s38.59-19.57,38.59-43.62-17.31-43.62-38.59-43.62-38.59,19.57-38.59,43.62ZM286.72,343.05c13.01,0,23.59,12.84,23.59,28.62s-10.58,28.62-23.59,28.62-23.59-12.84-23.59-28.62,10.58-28.62,23.59-28.62Z"
  })));
};
export default SvgHumidity01;